import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import "./styleLogin.css";
import logo from "../../logos/MSALogoFinal.png";

const AccessDenied = ({ moduleName, onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  const handleGoToMap = () => {
    navigate("/map");
  };

  const handleGoToCalls = () => {
    navigate("/calls");
  };

  return (
    <div style={{ background: "white", paddingBottom: "20px"}}>
      <div className="loginContainer" style={{ maxWidth: "500px" }}>
        <img
          src={logo}
          alt="logo"
          style={{
            width: "64%",
            height: "auto",
            margin: "auto",
            display: "block",
            marginBottom: "30px"
          }}
        />
        
        <Card elevation={3} sx={{ borderRadius: 2 }}>
          <CardContent sx={{ textAlign: "center", p: 4 }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h1" sx={{ 
                fontSize: "64px", 
                color: "#ff6b6b", 
                mb: 2 
              }}>
                <i className="fas fa-lock"></i>
              </Typography>
              
              <Typography variant="h4" sx={{ 
                color: "#333", 
                mb: 2,
                fontWeight: "600"
              }}>
                Access Restricted
              </Typography>
              
              <Typography variant="body1" sx={{ 
                color: "#666", 
                mb: 3,
                lineHeight: 1.6
              }}>
                You don't have access to the <strong>{moduleName}</strong> module. 
                Please contact support to get this feature added to your account.
              </Typography>
            </Box>
            
            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant="body2">
                Need help? Contact us at <strong>support@mainstreetassets.us</strong>
              </Typography>
            </Alert>
            
            <Box sx={{ 
              display: "flex", 
              gap: 2, 
              justifyContent: "center",
              flexWrap: "wrap"
            }}>
              <Button
                variant="outlined"
                onClick={handleBack}
                sx={{ 
                  minWidth: "120px",
                  borderColor: "#6c757d",
                  color: "#6c757d",
                  "&:hover": {
                    borderColor: "#5a6268",
                    backgroundColor: "#f8f9fa"
                  }
                }}
              >
                Go Back
              </Button>
              
              {moduleName !== "Map System" && (
                <Button
                  variant="contained"
                  onClick={handleGoToMap}
                  sx={{ 
                    minWidth: "120px",
                    backgroundColor: "#28a745",
                    "&:hover": {
                      backgroundColor: "#218838"
                    }
                  }}
                >
                  Go to Map
                </Button>
              )}
              
              {moduleName !== "Call Module" && (
                <Button
                  variant="contained"
                  onClick={handleGoToCalls}
                  sx={{ 
                    minWidth: "120px",
                    backgroundColor: "#007bff",
                    "&:hover": {
                      backgroundColor: "#0056b3"
                    }
                  }}
                >
                  Go to Calls
                </Button>
              )}
            </Box>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AccessDenied; 